var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Store } from "@ngrx/store";
import { getToken, getUrl } from "../account/account.reducer";
import { API_URL } from "../constants";
import sdkAPI from "passit-sdk-js/js/api";
var Api = /** @class */ (function (_super) {
    __extends(Api, _super);
    function Api(http, store) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.store = store;
        _this.store.select(getToken).subscribe(function (token) {
            if (token !== null) {
                _this.token = token;
            }
            else {
                _this.token = "";
            }
        });
        // Override base url if set explicitly.
        _this.store.select(getUrl).subscribe(function (url) {
            if (url) {
                _this.baseUrl = url;
            }
            else {
                _this.baseUrl = API_URL;
            }
        });
        return _this;
    }
    Api.prototype.sendInner = function (method, url, body, headers, returnsJSON) {
        return __awaiter(this, void 0, void 0, function () {
            var observe, requestOptions, resp, res_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        observe = "response";
                        requestOptions = {
                            body: body,
                            headers: new HttpHeaders(headers),
                            observe: observe
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.http.request(method, url, requestOptions).toPromise()];
                    case 2:
                        resp = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        res_1 = _a.sent();
                        throw { res: res_1 };
                    case 4:
                        if (!returnsJSON) return [3 /*break*/, 6];
                        return [4 /*yield*/, resp.body];
                    case 5: return [2 /*return*/, _a.sent()];
                    case 6: return [2 /*return*/, undefined];
                }
            });
        });
    };
    return Api;
}(sdkAPI));
export { Api };
